export default __webpack_public_path__ + "static/payment-9d50ee3324f5b9ec7669b21cdde64fb4.png";